import { defaultFontFamily } from '@/utils/string/const'

export const getTextWidth = (text: string, fontSize = '14px', fontWeight = 400, letterSpacing = 2.1): number => {
  const font = `${fontWeight} ${fontSize} ${defaultFontFamily}`
  const canvas = document.createElement('canvas')

  const context = canvas.getContext('2d')
  context!.font = font

  const letterSpacingOffset = text.length * letterSpacing

  return Math.round(context!.measureText(text).width + letterSpacingOffset)
}
